import { ApiPost } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'
import type {
  IGetProductCrossSellingProductListResponse,
  IGetOrderTypeProductDetailResponse,
  IAOEProductAttributeGetResponse,
  IProductAttributeGet,
  IOrderTypeSkuSearchGetList,
  IGetSkuListBySearchWordResponse,
  ISkuComponentGetListResponse,
  ISkuGetResponse,
} from '@/types/SkuTypes.ts'

export async function GetSkuListBySearchWord(
  orderTypeId: string,
  searchWord: string,
  pageSize: number | null,
): Promise<IGetSkuListBySearchWordResponse> {
  const url = await GetOrderEntryConnectorUrl('ordertypeskusearchgetlist')
  const request: IOrderTypeSkuSearchGetList = { orderTypeId, searchWord }

  if (pageSize) {
    request.pageFilter = { pageSize: pageSize }
  }
  return ApiPost(url, request)
}

export async function GetProductAttribute(
  productAttributeGet: IProductAttributeGet,
) {
  const url = await GetOrderEntryConnectorUrl('ProductAttributeGet')
  return await ApiPost(url, productAttributeGet)
}

export async function GetProductAttributeBatch(
  productCodes: Array<string>,
  attributename: string,
): Promise<Array<IAOEProductAttributeGetResponse> | null> {
  const url = await GetOrderEntryConnectorUrl('ProductAttributeGet[]')
  const requests = []
  for (const productCode of productCodes) {
    requests.push({
      productCode: productCode,
      attributeName: attributename,
    })
  }
  return await ApiPost(url, requests)
}

export async function GetProductCrossSellingProductListBatch(
  productCodes: Array<string>,
): Promise<Array<IGetProductCrossSellingProductListResponse> | null> {
  const url = await GetOrderEntryConnectorUrl('CrossSellingGetList[]')
  const requests = []
  for (const productCode of productCodes) {
    requests.push({
      productCode: productCode,
    })
  }
  return await ApiPost(url, requests)
}

export async function GetOrderTypeProductDetailBatch(
  orderTypeId: string,
  productCodes: Array<string>,
  includeCrossSells: boolean = false,
): Promise<Array<IGetOrderTypeProductDetailResponse> | null> {
  const url = await GetOrderEntryConnectorUrl('OrderTypeProductDetailGet[]')
  const requests = []
  for (const productCode of productCodes) {
    requests.push({
      orderTypeId: orderTypeId,
      productCode: productCode,
      includeCrossSells: includeCrossSells,
    })
  }
  return await ApiPost(url, requests)
}

export async function SkuComponentGetList(
  skuCodeParent: string,
): Promise<ISkuComponentGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('SkuComponentGetList')
  return ApiPost(url, { skuCodeParent })
}

export async function SkuGet(
  skuCode: string,
): Promise<ISkuGetResponse> {
  const url = await GetOrderEntryConnectorUrl('SkuGet')
  return ApiPost(url, { skuCode })
}
